class SearchForm {
    constructor(container) {
        this.container = container || document;
        this.clearButton = this.container.querySelector('.search-form__clear');
        this.searchInput = this.container.querySelector('.search-form__input');
        
        if (this.clearButton && this.searchInput) {
            this.init();
        }
    }

    init() {
        this.toggleClearButton();

        this.clearButton.addEventListener('click', () => this.handleClearClick());
        this.searchInput.addEventListener('input', () => this.toggleClearButton());
        this.searchInput.addEventListener('keyup', () => this.toggleClearButton());
    }

    toggleClearButton() {
        if (this.searchInput.value.trim().length > 0) {
            this.clearButton.classList.add('search-form__clear--visible');
        } else {
            this.clearButton.classList.remove('search-form__clear--visible');
        }
    }

    handleClearClick() {
        this.searchInput.value = '';
        this.searchInput.focus();
        this.toggleClearButton();
    }
}

document.addEventListener('DOMContentLoaded', function() {
    const searchForms = document.querySelectorAll('.search-form');

    if (searchForms.length) {
        searchForms.forEach((form) => {
            new SearchForm(form);
        });
    }
});
